import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-wallet",
  templateUrl: "./med-icon-wallet.component.html",
})
export class MedIconWalletComponent extends SvgMixinComponent {}
